import { render, staticRenderFns } from "./RecommendationOrderSummary.vue?vue&type=template&id=5baf25a5"
import script from "./RecommendationOrderSummary.vue?vue&type=script&lang=js"
export * from "./RecommendationOrderSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports